var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// D:/Projects/angular/ecell-hcst/~/core-js/modules/_has.js
// module id = ../../../../core-js/modules/_has.js
// module chunks = 0